module.exports = __webpack_public_path__ + "static/roche-press-day-5-59dbf710fca13c2556407d0e9d1e23d0.jpg";